import { render } from "./CategoryComboBox.vue?vue&type=template&id=2b38ff74&scoped=true"
import script from "./CategoryComboBox.vue?vue&type=script&lang=js"
export * from "./CategoryComboBox.vue?vue&type=script&lang=js"

import "./CategoryComboBox.vue?vue&type=style&index=0&id=2b38ff74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38ff74"]])

export default __exports__